export const valueDefaults = {
  petType           : '', // *
  breed             : '', // *
  petName           : '', // *
  petAge            : 0,
  dietaryGoals      : [],
  content           : '', // * 500 character min length
  image1            : null, // * lead image required
  image1Description : '',
  image2            : null,
  image2Description : '',
  image3            : null,
  image3Description : '',
  image4            : null,
  image4Description : '',
  image5            : null,
  image5Description : '',
  products          : [],
  termsAndConditions: [],
}

export const petTypeRadioOptions = [
  { labelText : 'Dog', value: 'dog', id: 'dog' },
  { labelText : 'Cat', value: 'cat', id: 'cat' },
];

export const dietaryGoalsCheckboxOptions = [
  {id: 'Dental Health', name: 'Dental Health', value: '6219076b5ee64b984885dffd', labelText: 'Dental Health', className : 'w25%'},
  {id: 'Sugar Sensitivities', name: 'Sugar Sensitivities', value: '6219076b5ee64b984885dffe', labelText: 'Sugar Sensitivities', className : 'w25%'},
  {id: 'Ear Issues', name: 'Ear Issues', value: '6219076b5ee64b984885dfff', labelText: 'Ear Issues', className : 'w25%'},
  {id: 'Energy', name: 'Energy', value: '6219076b5ee64b984885e000', labelText: 'Energy', className : 'w25%'},
  {id: 'Sensitive Stomach / Digestion', name: 'Sensitive Stomach / Digestion', value: '6219076b5ee64b984885e002', labelText: 'Sensitive Stomach / Digestion', className : 'w25%'},
  {id: 'Food Allergies / Intolerances', name: 'Food Allergies / Intolerances', value: '6219076b5ee64b984885e003', labelText: 'Food Allergies / Intolerances', className : 'w25%'},
  {id: 'Healthy Skin and Coat', name: 'Healthy Skin and Coat', value: '6219076b5ee64b984885e004', labelText: 'Healthy Skin and Coat', className : 'w25%'},
  {id: 'Bladder and Urine Sensitivities', name: 'Bladder and Urine Sensitivities', value: '6219076b5ee64b984885e005', labelText: 'Bladder and Urine Sensitivities', className : 'w25%'},
  {id: 'Weight Gain / High Calorie', name: 'Weight Gain / High Calorie', value: '6219076b5ee64b984885e006', labelText: 'Weight Gain / High Calorie', className : 'w25%'},
  {id: 'Heart Health', name: 'Heart Health', value: '6219076b5ee64b984885e007', labelText: 'Heart Health', className : 'w25%'},
  {id: 'Boosting immune system', name: 'Boosting immune system', value: '6219076b5ee64b984885e009', labelText: 'Boosting immune system', className : 'w25%'},
  {id: 'Joint Health / Mobility', name: 'Joint Health / Mobility', value: '6219076b5ee64b984885e00a', labelText: 'Joint Health / Mobility', className : 'w25%'},
  {id: 'Puppy Needs', name: 'Puppy Needs', value: '6219076b5ee64b984885e00b', labelText: 'Puppy Needs', className : 'w25%'},
  {id: 'Senior Needs', name: 'Senior Needs', value: '6219076b5ee64b984885e00c', labelText: 'Senior Needs', className : 'w25%'},
  {id: 'Weight Loss / Low Calorie', name: 'Weight Loss / Low Calorie', value: '6219076b5ee64b984885e00d', labelText: 'Weight Loss / Low Calorie', className : 'w25%'},
  {id: 'Anxiousness', name: 'Anxiousness', value: '6219076b5ee64b984885e00e', labelText: 'Anxiousness', className : 'w25%'},
  {id: 'Liver Health', name: 'Liver Health', value: '6219076b5ee64b984885e00f', labelText: 'Liver Health', className : 'w25%'},
  {id: 'Picky Eating / Fussy Eaters', name: 'Picky Eating / Fussy Eaters', value: '6219076b5ee64b984885e010', labelText: 'Picky Eating / Fussy Eaters', className : 'w25%'},
  {id: 'Kitten Needs', name: 'Kitten Needs', value: '6219076b5ee64b984885e011', labelText: 'Kitten Needs', className : 'w25%'},
  {id: 'Other', name: 'Other', value: '6219076b5ee64b984885e001', labelText: 'Other', className : 'w25%'},
  {id: 'None', name: 'None', value: '6219076b5ee64b984885e008', labelText: 'None', className : 'w25%'},
];

export const termsAndConditionsOptions = [
  {id: 'Terms-And-Conditions', name: 'Terms and Conditions', value: 'yes', labelText: `By checking the box I acknowledge that I have read, understand and agree to the <a class="c-red" href="https://www.thehonestkitchen.com/true-stories-terms/" target="_blank">Terms and Conditions</a>.`, className : 'w100%'},
];

export const dirtyDefaults = {
  petTypeDirty           : false,
  breedDirty             : false,
  petNameDirty           : false,
  contentDirty           : false,
  image1Dirty            : false,
  productsDirty          : false,
  termsAndConditionsDirty   : false,
}

export const errorDefaults = {
  petTypeRequiredError         : false,
  breedRequiredError           : false,
  petNameRequiredError         : false,
  contentRequiredError         : false,
  contentLengthMinError        : false,
  image1RequiredError           : false, // can count for any image
  productsRequiredError         : false,
  termsAndConditionsRequiredError : false,
}

export const validSteps = {
  step1: false,
  step2: false,
  step3: false
}
